import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from "../../services/api";

export const fetchUsers = createAsyncThunk('users/fetchUsers', async ({sortingColumn, sortingOrder}) => {
  const response = await apiClient.get('/users?sort=' + sortingColumn + '&order=' + sortingOrder);
  return response.data;
});

export const addUser = createAsyncThunk('users/addUser', async (userData) => {
  const response = await apiClient.post('/users', userData);
  return response.data;
});

export const updateUser = createAsyncThunk('users/updateUser', async ({ id, data }) => {
  const response = await apiClient.patch(`/users/${id}`, data);
  return response.data;
});

export const deleteUser = createAsyncThunk('users/deleteUser', async (userId) => {
  await apiClient.delete(`/users/${userId}`);
  return userId;
});

const userSlice = createSlice({
  name: 'users',
  initialState: {
    list: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(updateUser.fulfilled, (state, action) => {
        state.list = state.list.map(user =>
          user.id === action.payload.id ? { ...user, ...action.payload } : user
        );
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.errorMessage = 'Failed to edit user';
      })
      .addCase(fetchUsers.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.list = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.list = state.list.filter(user => user.id !== action.payload);
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.errorMessage = action.error.message || 'Failed to delete user';
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.list.push(action.payload);
      });
  },
});

export default userSlice.reducer;